import { render, staticRenderFns } from "./QuestionnaireBuilder.vue?vue&type=template&id=57fdc5c4&scoped=true&"
import script from "./QuestionnaireBuilder.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireBuilder.vue?vue&type=style&index=0&id=57fdc5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fdc5c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VIcon,VRow,VTextarea})
